import Base from '../Base';

const url = '/payment-invoices';
export default class PaymentInvoice extends Base {
  constructor(item) {
    super(item.id, url);

    this.can_edit = item.edit;
    this.number = item.number;
    this.sum = item.sum;
    this.is_paid = item.is_paid;
    this.date_at = item.date_at;
    this.contract_id = item.contract_id;
  }
}
